import request from '@/utils/request.js';
import Qs from 'qs';

/**
 * 机构用户管理
 */
export class OrgUserMgeControllerSvr {
  constructor() {
    this.baseurl = 'OrgUserMgeControllerSvr.assx/';
  }

  /**
   * 重置机构用户密码
   * token:String, loginId:String, pwd:String
   */
  ResetPassword(token, loginId, pwd) {
    return request.post(this.baseurl + 'ResetPassword', Qs.stringify({
      token: token,
      loginId: loginId,
      pwd: pwd
    }));
  }

  /**
   * 添加机构用户
   * token:String, user:User, contactor:String, telPhone:String, iDCard:String
   */
  AddOrgUser(token, user, contactor, telPhone, iDCard) {
    return request.post(this.baseurl + 'AddOrgUser', Qs.stringify({
      token: token,
      user: (typeof user === 'undefined' || user === null) ? '' : user.toString(),
      contactor: contactor,
      telPhone: telPhone,
      iDCard: iDCard
    }));
  }

  /**
   * 通过物业区域代码找到项目经理
   * token:String, eaAreaCode:String
   */
  GetRealtyManagerByEaAreaCode(token, eaAreaCode) {
    return request.post(this.baseurl + 'GetRealtyManagerByEaAreaCode', Qs.stringify({
      token: token,
      eaAreaCode: eaAreaCode
    }));
  }

  /**
   * 修改用户基础属性
   * token:String, user:User
   */
  ModifyUser(token, user) {
    return request.post(this.baseurl + 'ModifyUser', Qs.stringify({
      token: token,
      user: (typeof user === 'undefined' || user === null) ? '' : user.toString()
    }));
  }

  /**
   * 查看机构用户详情
   * token:String, loginId:String
   */
  GetOrgUserDetail(token, loginId) {
    return request.post(this.baseurl + 'GetOrgUserDetail', Qs.stringify({
      token: token,
      loginId: loginId
    }));
  }

  /**
   * 获取机构用户属性
   * token:String, loginId:String
   */
  GetOrgUserAttrib(token, loginId) {
    return request.post(this.baseurl + 'GetOrgUserAttrib', Qs.stringify({
      token: token,
      loginId: loginId
    }));
  }

  /**
   *  检查登录名 是否可用true：已存在，false:可用
   * token:String, loginId:String
   */
  CheckUserLoginIdIsExist(token, loginId) {
    return request.post(this.baseurl + 'CheckUserLoginIdIsExist', Qs.stringify({
      token: token,
      loginId: loginId
    }));
  }

  /**
   * 修改机构用户
   * token:String, user:User, contactor:String, telPhone:String
   */
  ModifyOrgUser(token, user, contactor, telPhone) {
    return request.post(this.baseurl + 'ModifyOrgUser', Qs.stringify({
      token: token,
      user: (typeof user === 'undefined' || user === null) ? '' : user.toString(),
      contactor: contactor,
      telPhone: telPhone
    }));
  }

  /**
   * 注销机构用户
   * token:String, loginId:String
   */
  CancellOrgUser(token, loginId) {
    return request.post(this.baseurl + 'CancellOrgUser', Qs.stringify({
      token: token,
      loginId: loginId
    }));
  }

  /**
   * 激活机构用户
   * token:String, loginId:String
   */
  ActivateOrgUser(token, loginId) {
    return request.post(this.baseurl + 'ActivateOrgUser', Qs.stringify({
      token: token,
      loginId: loginId
    }));
  }

  /**
   * 删除机构用户
   * token:String, loginId:String
   */
  DeleteOrgUser(token, loginId) {
    return request.post(this.baseurl + 'DeleteOrgUser', Qs.stringify({
      token: token,
      loginId: loginId
    }));
  }

  /**
   * 获取机构用户列表
   * token:String, orgCode:String, fullName:String, startIndex:int, maxSize:int
   */
  GetOrgUserList(token, orgCode, fullName, startIndex, maxSize) {
    return request.post(this.baseurl + 'GetOrgUserList', Qs.stringify({
      token: token,
      orgCode: orgCode,
      fullName: fullName,
      startIndex: startIndex,
      maxSize: maxSize
    }));
  }
}